import { ICreateNewsResponse } from 'shared/types/news.types';
import {
  ICreateFAQ,
  IUpdateFAQ,
  TDeleteFaqRequest,
  TFaqCategoryCreateRequest,
  TFaqCategoryGetRequest,
  TFaqCategoryGetResponse,
  TFaqGetRequest,
  TFaqGetResponse,
  TFaqGetResponsePaginated,
  TGetFaqByIdRequest,
  TGetFaqByIdResponse,
} from 'shared/types/faq.types';
import { IdResponse, MessageResponse } from 'shared/types/types';
import { edpApiV1 } from './index';

export const faqApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    getFaqCategory: build.query<TFaqCategoryGetResponse, TFaqCategoryGetRequest>({
      query: params => ({ url: `/v1/moderator/helper/faq_category`, method: 'GET', params }),
      providesTags: ['faq_category'],
    }),
    getFaqCategoryById: build.query<TGetFaqByIdResponse, TGetFaqByIdRequest>({
      query: params => ({ url: '/v1/moderator/helper/faq_categoryById', method: 'GET', params }),
      providesTags: ['faq_category'],
    }),
    updateFaqCategory: build.mutation<ICreateNewsResponse, TGetFaqByIdResponse>({
      query: faq => ({
        url: `/v1/moderator/helper/faq_category`,
        method: 'PATCH',
        body: faq,
      }),
      invalidatesTags: ['faq_category'],
    }),
    deleteFaqCategory: build.mutation<MessageResponse, TDeleteFaqRequest>({
      query: params => ({
        url: `/v1/moderator/helper/faq_category`,
        method: 'DELETE',
        params,
      }),
      invalidatesTags: ['faq_category'],
    }),
    createFaqCategory: build.mutation<ICreateNewsResponse, TFaqCategoryCreateRequest>({
      query: body => ({
        url: `/v1/moderator/helper/faq_category`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['faq_category'],
    }),

    getFaq: build.query<TFaqGetResponsePaginated, TFaqGetRequest>({
      query: params => ({ url: `/v1/moderator/helper/faq`, method: 'GET', params }),
      providesTags: ['faq'],
    }),
    getFaqById: build.query<TFaqGetResponse, TGetFaqByIdRequest>({
      query: params => ({ url: '/v1/moderator/helper/faqById', method: 'GET', params }),
      providesTags: ['faq'],
    }),
    updateFaq: build.mutation<ICreateNewsResponse, IUpdateFAQ>({
      query: faq => ({
        url: `/v1/moderator/helper/faq`,
        method: 'PATCH',
        body: faq,
      }),
      invalidatesTags: ['faq'],
    }),
    createFaq: build.mutation<ICreateNewsResponse, ICreateFAQ>({
      query: body => ({
        url: `/v1/moderator/helper/faq`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['faq'],
    }),
    deleteFaq: build.mutation<ICreateNewsResponse, IdResponse>({
      query: params => ({
        url: `/v1/moderator/helper/faq`,
        method: 'DELETE',
        params,
      }),
      invalidatesTags: ['faq'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateFaqCategoryMutation,
  useGetFaqCategoryByIdQuery,
  useGetFaqCategoryQuery,
  useLazyGetFaqQuery,
  useDeleteFaqMutation,
  useUpdateFaqCategoryMutation,
  useDeleteFaqCategoryMutation,
  useLazyGetFaqCategoryQuery,
  useGetFaqByIdQuery,
  useGetFaqQuery,
  useCreateFaqMutation,
  useUpdateFaqMutation,
} = faqApi;
